export default __webpack_public_path__ + "static/media/Carouselimage1.283da300.jpg";